import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./FormSettings.scss";

// prop types
import userPropTypes from "../../../propTypes/userPropTypes";

// actions
import * as appHeaderActions from "../../../actions/appHeaderActions";
import * as userActions from "../../../actions/userActions";

//components
import withRouter from "../../../coraWebComponents/utils/withRouter";
import Button from "../../../coraWebComponents/buttons/Button";
import Input from "../../../coraWebComponents/forms/Input";
import Tooltip from "../../../coraWebComponents/forms/Tooltip";
import LoadingPanel from "../../../coraWebComponents/LoadingPanel";
import Routes from "../../../constants/Routes";

class FormSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  // FORM METHODS
  onSubmitHandle = async (event) => {
    event.preventDefault();
    const { updateUser, navigate } = this.props;
    const { N_UZ, MOBIL, password } = this.state;

    await updateUser({ N_UZ, MOBIL, HESLO: password });
    navigate(Routes.HOME);
  };
  onChange = (name, value) => {
    this.setState({ [name]: value });
  };

  // SYSTEM METHODS
  componentDidMount = () => {
    const { showAppHeader, changeHeaderTitle, user } = this.props;

    showAppHeader(false);
    changeHeaderTitle("");

    // get only necessary data from 'odberatel' object and set them to state
    this.setState(
      (({ N_UZ, MOBIL }) => ({
        N_UZ,
        MOBIL,
        password: "",
        verifyPassword: "",
      }))(user.Uzivatel)
    );
  };
  render() {
    const { isLoading } = this.props;
    const { N_UZ, MOBIL, disabled, password, verifyPassword } = this.state;

    const media = window.matchMedia('only screen and (min-width: 768px)');
    const className = media ? "col-6 offset-3 p-0 forWeb" : "col p-0 forMobile";

    return (
      <div className="row m-0">
        <div className={className}>
          <div className="card formular">
            <div className="form-body">
              <Tooltip>
                <form
                  className="k-form changeContactData"
                  onSubmit={this.onSubmitHandle}
                >
                  {/* TITLE */}
                  <div className="card-title">
                    <div>Zmena údajov</div>
                  </div>

                  {/* FIELDS */}
                  <p>&nbsp;</p>
                  <div className="k-form-field">
                    <span>{"Email:"}</span>
                    <Input
                      title="Meníte Váš prihlasovací email."
                      name="N_UZ"
                      type="email"
                      value={N_UZ}
                      onChange={this.onChange}
                      validationMessage="Nesprávny format mailovej adresy"
                      disabled
                    />
                  </div>
                  <div className="k-form-field">
                    <span>{"Telefónny kontakt:"}</span>
                    <Input
                      title="Meníte Váš telefónny kontakt."
                      type="tel"
                      name="MOBIL"
                      value={MOBIL}
                      onChange={this.onChange}
                      placeholder="+421999999999"
                      pattern="([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)"
                      validationMessage="Nesprávny formát telefónneho čísla"
                      disabled={isLoading || disabled}
                    />
                  </div>

                  <div className="k-form-field">
                    <span>Nové heslo:</span>
                    <Input
                      title={""}
                      type="password"
                      name="password"
                      onChange={this.onChange}
                      value={password}
                      disabled={disabled}
                      pattern="(?=.*[a-zA-Z].*)(?=.*[0-9].*)(?=.*[@$!%*?#^+\-\/].*)^[a-zA-Z0-9@$!%*?#^+\-\/+*\/-]{8,}"
                      validationMessage="Heslo musí pozostávať aspoň z 8 znakov a musí obsahovať aspoň 
                                          jeden znak a-z, 
                                          jeden znak A-Z, 
                                          jeden znak 0-9 a 
                                          jeden zo znakov: +-*/@?!%$#^."
                    />
                  </div>
                  <div className="k-form-field">
                    <span>Overenie hesla:</span>
                    <Input
                      title={""}
                      type="password"
                      name="verifyPassword"
                      onChange={this.onChange}
                      value={verifyPassword}
                      disabled={disabled}
                      validationMessage="Nezhoduje sa s novým heslom"
                      valid={password === verifyPassword}
                    />
                  </div>

                  {/* SUBMIT BUTTON */}
                  <div className="k-form-field">
                    <Button
                      primary={true}
                      disabled={isLoading || disabled}
                      label="Zmeniť"
                      type="submit"
                    />
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <LoadingPanel isLoading={isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.odberatel.isLoading,
  user: state.user.data,
});

const mapDispatchToProps = (dispatch) => ({
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
  updateUser: async (data) => await dispatch(userActions.updateUser(data)),
});

FormSettings.propTypes = {
  changeHeaderTitle: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  showAppHeader: PropTypes.func,
  updateUser: PropTypes.func,
  user: userPropTypes.user,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FormSettings)
);
